import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { createComment, listComments } from './comments-api';
import { COMMENTS_QUERY_KEY } from './comments-constants';

/** All comments for the domain of `url` - one fetch shared by every section's thread. */
export const useComments = (url: string | undefined) =>
  useQuery({
    queryKey: [COMMENTS_QUERY_KEY, url],
    queryFn: () => listComments(url ?? ''),
    enabled: Boolean(url)
  });

export const useAddComment = (url: string | undefined) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ anchor, body }: { anchor: string; body: string }) =>
      createComment(url ?? '', anchor, body),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [COMMENTS_QUERY_KEY, url] })
  });
};
